export const CustomersResource = {
  name: "Customers",
  path: "/sales/customers",
  access: ["read-customers"],
};
